module.exports = __webpack_public_path__ + "static/media/lightning-fast.4d682c6d.svg";